function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-44"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-44",
    cx: 250,
    cy: 327.78,
    rx: 244.48,
    ry: 141.15,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Cloud--inject-44",
    d: "M156.24,88.75c-3.21-.48-5.35-1.51-5.78-3.21s1-3.9,2.66-4.56a14.32,14.32,0,0,1,6.93-.85c-.3-2.94,2.42-6.43,5.1-7.91s7.54-1.83,10.28.43c.79-5.29,4.19-7.88,9.51-9.73,2.93-1,9-1.63,13.65,2.62,3.08-5.77,12.28-9.22,21.72-5.45a16.42,16.42,0,0,1,8.51,8,18.28,18.28,0,0,1,1.45,6.51,8.26,8.26,0,0,1,8.75-.43,6.79,6.79,0,0,1,3.18,6.11,17.49,17.49,0,0,1,5.67,1.31c2,.86,4.17,2.79,3.43,4.81-.56,1.53-2.46,2.13-4.14,2.36a25.15,25.15,0,0,1-10-.62,17.87,17.87,0,0,1-20.35-.49,33.05,33.05,0,0,1-4.2,2.72,16.86,16.86,0,0,1-4.89,1.31c-2.85.3-6.87-.24-9.09-2.11a2,2,0,0,0-1.06-.59,1.79,1.79,0,0,0-.91.32,13.23,13.23,0,0,1-13.92-1,13.23,13.23,0,0,1-18.42-.75A14.61,14.61,0,0,1,156.24,88.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--cloud--inject-44",
    d: "M126.41,64.21c2.4-.36,4-1.14,4.32-2.41a3.27,3.27,0,0,0-2-3.4,10.64,10.64,0,0,0-5.17-.63c.22-2.2-1.8-4.81-3.8-5.91s-5.64-1.37-7.68.32c-.59-4-3.13-5.88-7.11-7.27a10.41,10.41,0,0,0-10.18,2c-2.31-4.3-9.17-6.89-16.22-4.07a12.25,12.25,0,0,0-6.36,6,13.62,13.62,0,0,0-1.08,4.86,6.2,6.2,0,0,0-6.54-.32,5.08,5.08,0,0,0-2.37,4.57,12.85,12.85,0,0,0-4.24,1c-1.52.64-3.11,2.08-2.56,3.58.42,1.15,1.84,1.6,3.09,1.77A18.67,18.67,0,0,0,66,63.73a13.34,13.34,0,0,0,15.19-.37,25.48,25.48,0,0,0,3.15,2,12.41,12.41,0,0,0,3.65,1c2.13.23,5.12-.18,6.79-1.58a1.41,1.41,0,0,1,.79-.43,1.29,1.29,0,0,1,.67.23,9.89,9.89,0,0,0,10.4-.74,9.9,9.9,0,0,0,13.76-.55A10.88,10.88,0,0,0,126.41,64.21Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountain--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mountain--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rock--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "201.54 260.58 294.5 317.02 338.62 328.89 397.4 307.1 449.9 307.24 476.13 274.27 449.9 185.48 430.99 176.52 412.78 90.82 341.79 93.31 328.62 139.76 307.47 146.11 287.08 186.44 239.51 198.11 201.54 260.58",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.11 260.05 333.4 281.88 260.42 247.06 335.01 267.03 395.11 260.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.62 328.89 333.4 281.88 395.11 260.05 397.4 307.1 338.62 328.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.03 218.06 449.9 307.24 476.13 274.27 449.9 185.48 435.03 218.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.79 93.31 403.24 111.01 412.78 90.82 341.79 93.31",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.79 93.31 403.24 111.01 412.78 90.82 341.79 93.31",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.99 176.52 415.34 209.9 327.11 226.09 435.03 218.06 449.9 185.48 430.99 176.52",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.99 176.52 415.34 209.9 403.24 111.01 412.78 90.82 430.99 176.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.51 198.11 287.08 186.44 306.98 215.35 239.51 198.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.62 139.76 344.13 163.31 401.38 169.05 331.61 175.73 307.47 146.11 328.62 139.76",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rock--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "168.11 311.25 235.28 339.08 294.5 317.02 293.39 284.6 263.35 263.38 237.05 254.12 210.61 245.62 186.76 251.55 168.11 311.25",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.35 263.38 252.53 289.38 217.62 294.58 178.7 284.4 237.99 310.39 281.46 299.63 293.39 284.6 263.35 263.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "235.28 339.08 237.99 310.39 281.46 299.63 293.39 284.6 294.5 317.02 235.28 339.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.61 245.62 186.76 251.55 213.33 261.34 237.05 254.12 210.61 245.62",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rock--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "395.01 345.79 418.26 356.85 418.26 338.13 402.95 329.06 395.01 345.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.47 332.18 418.26 338.13 418.26 356.85 433.57 349.48 428.47 332.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.95 329.06 416.85 327.64 428.47 332.18 418.26 338.13 402.95 329.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.62 343.49 431.99 346.33 439.2 344.91 434.35 342.66 431.04 342.66 427.62 343.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.81 355.78 431.99 346.33 439.2 344.91 441.09 349.64 430.81 355.78",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.62 343.49 423.95 354.13 430.81 355.78 431.99 346.33 427.62 343.49",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--rock--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "395.01 345.79 418.26 356.85 418.26 338.13 402.95 329.06 395.01 345.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.47 332.18 418.26 338.13 418.26 356.85 433.57 349.48 428.47 332.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.95 329.06 416.85 327.64 428.47 332.18 418.26 338.13 402.95 329.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.62 343.49 431.99 346.33 439.2 344.91 434.35 342.66 431.04 342.66 427.62 343.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.81 355.78 431.99 346.33 439.2 344.91 441.09 349.64 430.81 355.78",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.62 343.49 423.95 354.13 430.81 355.78 431.99 346.33 427.62 343.49",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Road--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Way--inject-44",
    d: "M403,99.77c-25.73,9.42-30.3,17-32.53,63.19a79.57,79.57,0,0,1-2.8,18.3c-4.59,15.92-14.64,25.34-30.62,34.09-34.3,18.81-35.43,41.53-35.69,57.18-.58,34.71-.4,62.79-48.9,99.65-41,31.15-87.23,54.64-105.83,105.67C112.26,470,80.05,458,52.24,442a235.67,235.67,0,0,1-26.61-17.76c22-42.9,94.91-68.95,129.71-79.43,36.23-10.92,88.51-26.24,97.93-71.79,6.92-33.48,6.15-50.51,61.84-78.4,12.48-6.25,20.68-12.76,26.27-19.42,15-17.82,11.15-36.72,20.56-54.76,9.15-17.54,25.27-20.62,25.27-20.62Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--way--inject-44",
    d: "M403,99.77c-25.73,9.42-30.3,17-32.53,63.19a79.57,79.57,0,0,1-2.8,18.3c-4.59,15.92-14.64,25.34-30.62,34.09-34.3,18.81-35.43,41.53-35.69,57.18-.58,34.71-.4,62.79-48.9,99.65-41,31.15-87.23,54.64-105.83,105.67C112.26,470,80.05,458,52.24,442a235.67,235.67,0,0,1-26.61-17.76c22-42.9,94.91-68.95,129.71-79.43,36.23-10.92,88.51-26.24,97.93-71.79,6.92-33.48,6.15-50.51,61.84-78.4,12.48-6.25,20.68-12.76,26.27-19.42,15-17.82,11.15-36.72,20.56-54.76,9.15-17.54,25.27-20.62,25.27-20.62Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.74,422.71a4,4,0,0,1-3.88-3.21l-.92-4.88a54.5,54.5,0,0,1-6.29-1.54l-8.59,4a4.68,4.68,0,0,1-2,.41,4.83,4.83,0,0,1-2.38-.6l-8.48-4.9a3.29,3.29,0,0,1-.28-5.62l5.2-3.74a18.69,18.69,0,0,1-1.35-2L298,399.91a3.8,3.8,0,0,1-3.55-3.79v-6.3A3.8,3.8,0,0,1,298,386l10.84-.69a19.73,19.73,0,0,1,1.35-2l-5.2-3.74a3.29,3.29,0,0,1,.28-5.62l8.48-4.89a4.84,4.84,0,0,1,2.38-.61,4.6,4.6,0,0,1,1.95.41l8.65,4a54.18,54.18,0,0,1,6.24-1.53l.92-4.88a4,4,0,0,1,3.88-3.2h12.47a4,4,0,0,1,3.87,3.21l.93,4.87a55,55,0,0,1,6.29,1.54l8.6-4a4.6,4.6,0,0,1,2-.41,4.87,4.87,0,0,1,2.38.61l8.48,4.89a3.29,3.29,0,0,1,.28,5.62l-5.2,3.74a18.11,18.11,0,0,1,1.34,2L390,386a3.8,3.8,0,0,1,3.55,3.79v6.3a3.8,3.8,0,0,1-3.55,3.79l-10.84.68a18.69,18.69,0,0,1-1.35,2l5.2,3.74a3.29,3.29,0,0,1-.28,5.62l-8.49,4.9a4.77,4.77,0,0,1-2.37.6,4.68,4.68,0,0,1-2-.41l-8.64-4a54.18,54.18,0,0,1-6.24,1.53l-.93,4.88a4,4,0,0,1-3.87,3.21ZM331,387c-2.92,1.68-4.6,3.86-4.6,6s1.68,4.27,4.6,6a29,29,0,0,0,26,0c2.92-1.69,4.6-3.86,4.6-6s-1.68-4.28-4.6-6a29,29,0,0,0-26,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.37,369.07l-8.48-4.9a2.26,2.26,0,0,0-1.87-.08l-8.6,4a3.24,3.24,0,0,1-2,.12,50.7,50.7,0,0,0-6.67-1.59,1.63,1.63,0,0,1-1.24-1.21l-1.08-5.66a1.32,1.32,0,0,0-1.25-1H337.74a1.31,1.31,0,0,0-1.25,1l-1.08,5.66a1.63,1.63,0,0,1-1.24,1.21,52.32,52.32,0,0,0-6.67,1.58,3.16,3.16,0,0,1-2-.11l-8.6-4a2.26,2.26,0,0,0-1.87.08l-8.48,4.9a.69.69,0,0,0-.4.57h0l0,7.35h0a.71.71,0,0,0,.34.57l3.9,2.81a1.87,1.87,0,0,1-1,.4l-11.3.71a1.16,1.16,0,0,0-1.06,1.13v4.8h0l0,8.84a1.14,1.14,0,0,0,1.06,1.13l11.3.71a1.89,1.89,0,0,1,1,.42l-3.88,2.79a.71.71,0,0,0-.34.56h0l0,7.36h0a.69.69,0,0,0,.4.58L315,414.7a2.26,2.26,0,0,0,1.87.09l8.6-4a3.07,3.07,0,0,1,2-.12,49.28,49.28,0,0,0,6.68,1.58,1.64,1.64,0,0,1,1.24,1.21l1.08,5.67a1.32,1.32,0,0,0,1.25,1h12.47a1.33,1.33,0,0,0,1.25-1l1.08-5.67a1.63,1.63,0,0,1,1.24-1.21,49.5,49.5,0,0,0,6.67-1.58,3.09,3.09,0,0,1,2,.12l8.6,4a2.26,2.26,0,0,0,1.87-.09l8.48-4.89a.7.7,0,0,0,.4-.56h0l0-7.38h0a.72.72,0,0,0-.34-.56l-3.9-2.81a1.87,1.87,0,0,1,1-.4l11.3-.71a1.15,1.15,0,0,0,1.06-1.13V382.61a1.15,1.15,0,0,0-1.06-1.13l-11.3-.71a1.89,1.89,0,0,1-1-.42l3.88-2.79a.72.72,0,0,0,.34-.56h0l0-7.36h0A.71.71,0,0,0,381.37,369.07Zm-57.24,19c.61-2,2.42-4,5.52-5.81,7.91-4.56,20.74-4.56,28.65,0,2.9,1.68,4.79,3.52,5.65,5.41-.68,2.32-2.56,4.54-5.65,6.32-7.91,4.57-20.74,4.57-28.65,0C326.73,392.35,324.9,390.28,324.13,388.11Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.37,369.07l-8.48-4.9a2.26,2.26,0,0,0-1.87-.08l-8.6,4a3.24,3.24,0,0,1-2,.12,50.7,50.7,0,0,0-6.67-1.59,1.63,1.63,0,0,1-1.24-1.21l-1.08-5.66a1.32,1.32,0,0,0-1.25-1H337.74a1.31,1.31,0,0,0-1.25,1l-1.08,5.66a1.63,1.63,0,0,1-1.24,1.21,52.32,52.32,0,0,0-6.67,1.58,3.16,3.16,0,0,1-2-.11l-8.6-4a2.26,2.26,0,0,0-1.87.08l-8.48,4.9a.69.69,0,0,0-.4.57h0l0,7.35h0a.71.71,0,0,0,.34.57l3.9,2.81a1.87,1.87,0,0,1-1,.4l-11.3.71a1.16,1.16,0,0,0-1.06,1.13v4.8h0l0,8.84a1.14,1.14,0,0,0,1.06,1.13l11.3.71a1.89,1.89,0,0,1,1,.42l-3.88,2.79a.71.71,0,0,0-.34.56h0l0,7.36h0a.69.69,0,0,0,.4.58L315,414.7a2.26,2.26,0,0,0,1.87.09l8.6-4a3.07,3.07,0,0,1,2-.12,49.28,49.28,0,0,0,6.68,1.58,1.64,1.64,0,0,1,1.24,1.21l1.08,5.67a1.32,1.32,0,0,0,1.25,1h12.47a1.33,1.33,0,0,0,1.25-1l1.08-5.67a1.63,1.63,0,0,1,1.24-1.21,49.5,49.5,0,0,0,6.67-1.58,3.09,3.09,0,0,1,2,.12l8.6,4a2.26,2.26,0,0,0,1.87-.09l8.48-4.89a.7.7,0,0,0,.4-.56h0l0-7.38h0a.72.72,0,0,0-.34-.56l-3.9-2.81a1.87,1.87,0,0,1,1-.4l11.3-.71a1.15,1.15,0,0,0,1.06-1.13V382.61a1.15,1.15,0,0,0-1.06-1.13l-11.3-.71a1.89,1.89,0,0,1-1-.42l3.88-2.79a.72.72,0,0,0,.34-.56h0l0-7.36h0A.71.71,0,0,0,381.37,369.07Zm-57.24,19c.61-2,2.42-4,5.52-5.81,7.91-4.56,20.74-4.56,28.65,0,2.9,1.68,4.79,3.52,5.65,5.41-.68,2.32-2.56,4.54-5.65,6.32-7.91,4.57-20.74,4.57-28.65,0C326.73,392.35,324.9,390.28,324.13,388.11Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,391.77a2.08,2.08,0,0,0-1.52-1L298.13,390a1.14,1.14,0,0,1-1.05-1.13v-1.49l0,8.84a1.16,1.16,0,0,0,1.06,1.13l11.3.71a1.9,1.9,0,0,1,1,.41l2.83-2a.88.88,0,0,0,.12-1.37A17.52,17.52,0,0,1,311,391.77ZM306.16,377h0a.72.72,0,0,0,.34.56l3.9,2.82a2,2,0,0,0,.56-.62,17.34,17.34,0,0,1,2.4-3.33.89.89,0,0,0-.12-1.38l-6.72-4.84a.78.78,0,0,1-.34-.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.3,377.49c-7.91-4.56-20.74-4.57-28.65,0-5,2.89-6.84,6.91-5.52,10.63.59-2,2.42-4,5.52-5.82,7.91-4.57,20.73-4.56,28.65,0,2.89,1.67,4.79,3.51,5.65,5.39C365,384.1,363.11,380.27,358.3,377.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.86,389.06a1.18,1.18,0,0,1-1.05,1l-11.29.71a1.66,1.66,0,0,0-.57.15l0,7.37a1.54,1.54,0,0,1,.56-.16l11.3-.72a1.14,1.14,0,0,0,1.06-1.12Zm-9.09-19.42h0a.45.45,0,0,1,0,.22.48.48,0,0,1-.14.22.64.64,0,0,1-.15.13l-6.72,4.84a.73.73,0,0,0-.16.14.84.84,0,0,0-.21.42.66.66,0,0,0,0,.28.8.8,0,0,0,0,.15,1,1,0,0,0,.23.39l.12.14a17.21,17.21,0,0,1,2.28,3.18,2.16,2.16,0,0,0,.53.61l3.89-2.79a.75.75,0,0,0,.34-.57h0Zm0,32.3a.74.74,0,0,1-.4.52l-8.48,4.89a2.15,2.15,0,0,1-1.32.23v7.35a2.18,2.18,0,0,0,1.31-.23l8.48-4.89a.7.7,0,0,0,.4-.56Zm-55.4,1.31a2.88,2.88,0,0,0-.84.2l-8.6,4a1.81,1.81,0,0,1-.76.16l0,7.34a2.4,2.4,0,0,0,.77-.15l8.59-4a2.66,2.66,0,0,1,.84-.19Zm24.89,9a1.29,1.29,0,0,1-1.05.56H337.74a1.29,1.29,0,0,1-.76-.28v7.35a1.31,1.31,0,0,0,.75.28h12.46a1.35,1.35,0,0,0,1.1-.63Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.86,389.06a1.18,1.18,0,0,1-1.05,1l-11.29.71a1.66,1.66,0,0,0-.57.15l0,7.37a1.54,1.54,0,0,1,.56-.16l11.3-.72a1.14,1.14,0,0,0,1.06-1.12Zm-9.09-19.42h0a.45.45,0,0,1,0,.22.48.48,0,0,1-.14.22.64.64,0,0,1-.15.13l-6.72,4.84a.73.73,0,0,0-.16.14.84.84,0,0,0-.21.42.66.66,0,0,0,0,.28.8.8,0,0,0,0,.15,1,1,0,0,0,.23.39l.12.14a17.21,17.21,0,0,1,2.28,3.18,2.16,2.16,0,0,0,.53.61l3.89-2.79a.75.75,0,0,0,.34-.57h0Zm0,32.3a.74.74,0,0,1-.4.52l-8.48,4.89a2.15,2.15,0,0,1-1.32.23v7.35a2.18,2.18,0,0,0,1.31-.23l8.48-4.89a.7.7,0,0,0,.4-.56Zm-55.4,1.31a2.88,2.88,0,0,0-.84.2l-8.6,4a1.81,1.81,0,0,1-.76.16l0,7.34a2.4,2.4,0,0,0,.77-.15l8.59-4a2.66,2.66,0,0,1,.84-.19Zm24.89,9a1.29,1.29,0,0,1-1.05.56H337.74a1.29,1.29,0,0,1-.76-.28v7.35a1.31,1.31,0,0,0,.75.28h12.46a1.35,1.35,0,0,0,1.1-.63Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,364.09l-8.6,4a3.24,3.24,0,0,1-2,.12,50.7,50.7,0,0,0-6.67-1.59,1.63,1.63,0,0,1-1.24-1.21l-1.08-5.66a1.32,1.32,0,0,0-1.25-1H337.74a1.31,1.31,0,0,0-1.25,1l-1.08,5.66a1.63,1.63,0,0,1-1.24,1.21,52.32,52.32,0,0,0-6.67,1.58,3.16,3.16,0,0,1-2-.11l-8.6-4a2.26,2.26,0,0,0-1.87.08l-8.48,4.9a.63.63,0,0,0-.06,1.14l6.72,4.84a.9.9,0,0,1,.12,1.38,16.63,16.63,0,0,0-2.4,3.33,2.08,2.08,0,0,1-1.52,1l-11.3.71a1.15,1.15,0,0,0-1.06,1.13v6.3a1.14,1.14,0,0,0,1.06,1.13l11.3.71a2.06,2.06,0,0,1,1.52,1,17.21,17.21,0,0,0,2.4,3.33.9.9,0,0,1-.12,1.38l-6.72,4.83a.63.63,0,0,0,.06,1.15l8.48,4.89a2.3,2.3,0,0,0,1.87.09l8.6-4a3.13,3.13,0,0,1,2-.11,50.83,50.83,0,0,0,6.68,1.58,1.64,1.64,0,0,1,1.24,1.21l1.07,5.67a1.33,1.33,0,0,0,1.26,1h12.47a1.33,1.33,0,0,0,1.25-1l1.08-5.67a1.63,1.63,0,0,1,1.24-1.21,51.06,51.06,0,0,0,6.67-1.58,3.09,3.09,0,0,1,2,.12l8.6,4a2.3,2.3,0,0,0,1.87-.09l8.48-4.89a.63.63,0,0,0,.06-1.15l-6.72-4.84a.89.89,0,0,1-.13-1.37,16.4,16.4,0,0,0,2.4-3.33,2.1,2.1,0,0,1,1.53-1l11.3-.71a1.15,1.15,0,0,0,1.06-1.13v-6.3a1.15,1.15,0,0,0-1.06-1.13l-11.3-.71a2.11,2.11,0,0,1-1.53-1,16.45,16.45,0,0,0-2.39-3.33.9.9,0,0,1,.12-1.38l6.72-4.84a.63.63,0,0,0-.06-1.14l-8.48-4.9A2.26,2.26,0,0,0,371,364.09Zm-12.72,13.4c7.91,4.57,7.91,12,0,16.54s-20.74,4.57-28.65,0-7.91-12,0-16.54S350.39,372.92,358.3,377.49Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371,364.09l-8.6,4a3.24,3.24,0,0,1-2,.12,50.7,50.7,0,0,0-6.67-1.59,1.63,1.63,0,0,1-1.24-1.21l-1.08-5.66a1.32,1.32,0,0,0-1.25-1H337.74a1.31,1.31,0,0,0-1.25,1l-1.08,5.66a1.63,1.63,0,0,1-1.24,1.21,52.32,52.32,0,0,0-6.67,1.58,3.16,3.16,0,0,1-2-.11l-8.6-4a2.26,2.26,0,0,0-1.87.08l-8.48,4.9a.63.63,0,0,0-.06,1.14l6.72,4.84a.9.9,0,0,1,.12,1.38,16.63,16.63,0,0,0-2.4,3.33,2.08,2.08,0,0,1-1.52,1l-11.3.71a1.15,1.15,0,0,0-1.06,1.13v6.3a1.14,1.14,0,0,0,1.06,1.13l11.3.71a2.06,2.06,0,0,1,1.52,1,17.21,17.21,0,0,0,2.4,3.33.9.9,0,0,1-.12,1.38l-6.72,4.83a.63.63,0,0,0,.06,1.15l8.48,4.89a2.3,2.3,0,0,0,1.87.09l8.6-4a3.13,3.13,0,0,1,2-.11,50.83,50.83,0,0,0,6.68,1.58,1.64,1.64,0,0,1,1.24,1.21l1.07,5.67a1.33,1.33,0,0,0,1.26,1h12.47a1.33,1.33,0,0,0,1.25-1l1.08-5.67a1.63,1.63,0,0,1,1.24-1.21,51.06,51.06,0,0,0,6.67-1.58,3.09,3.09,0,0,1,2,.12l8.6,4a2.3,2.3,0,0,0,1.87-.09l8.48-4.89a.63.63,0,0,0,.06-1.15l-6.72-4.84a.89.89,0,0,1-.13-1.37,16.4,16.4,0,0,0,2.4-3.33,2.1,2.1,0,0,1,1.53-1l11.3-.71a1.15,1.15,0,0,0,1.06-1.13v-6.3a1.15,1.15,0,0,0-1.06-1.13l-11.3-.71a2.11,2.11,0,0,1-1.53-1,16.45,16.45,0,0,0-2.39-3.33.9.9,0,0,1,.12-1.38l6.72-4.84a.63.63,0,0,0-.06-1.14l-8.48-4.9A2.26,2.26,0,0,0,371,364.09Zm-12.72,13.4c7.91,4.57,7.91,12,0,16.54s-20.74,4.57-28.65,0-7.91-12,0-16.54S350.39,372.92,358.3,377.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.21,413.25H337.74a1.72,1.72,0,0,1-1.66-1.38L335,406.21a1.22,1.22,0,0,0-.9-.88,49.39,49.39,0,0,1-6.73-1.6,2.79,2.79,0,0,0-1.67.1l-8.59,4a2.71,2.71,0,0,1-2.26-.1l-8.48-4.89a1.12,1.12,0,0,1-.61-.9,1.14,1.14,0,0,1,.52-.95l6.72-4.83a.48.48,0,0,0,.21-.35.52.52,0,0,0-.15-.41A17.57,17.57,0,0,1,310.6,392a1.68,1.68,0,0,0-1.19-.8l-11.3-.72a1.56,1.56,0,0,1-1.44-1.54v-6.3a1.56,1.56,0,0,1,1.44-1.54l11.3-.72a1.67,1.67,0,0,0,1.19-.79,17.27,17.27,0,0,1,2.46-3.41.55.55,0,0,0,.15-.42.49.49,0,0,0-.21-.34l-6.72-4.84a1.13,1.13,0,0,1-.52-.95,1.11,1.11,0,0,1,.61-.89l8.48-4.9a2.71,2.71,0,0,1,2.26-.1l8.59,4a2.8,2.8,0,0,0,1.67.1,50.92,50.92,0,0,1,6.73-1.6,1.22,1.22,0,0,0,.9-.88l1.08-5.66a1.74,1.74,0,0,1,1.66-1.38h12.47a1.74,1.74,0,0,1,1.66,1.38l1.08,5.66a1.22,1.22,0,0,0,.9.88,50.92,50.92,0,0,1,6.73,1.6,2.72,2.72,0,0,0,1.67-.1l8.59-4a2.71,2.71,0,0,1,2.26.1l8.48,4.9a1.07,1.07,0,0,1,.6.89,1.09,1.09,0,0,1-.51.95L375,375.39a.49.49,0,0,0-.21.34.55.55,0,0,0,.15.42,17.27,17.27,0,0,1,2.46,3.41,1.65,1.65,0,0,0,1.19.79l11.3.72a1.56,1.56,0,0,1,1.44,1.54v6.3a1.56,1.56,0,0,1-1.44,1.54l-11.3.72a1.67,1.67,0,0,0-1.19.8,17.57,17.57,0,0,1-2.46,3.41.52.52,0,0,0-.15.41.48.48,0,0,0,.21.35l6.72,4.83a1.1,1.1,0,0,1,.51.95,1.09,1.09,0,0,1-.6.9l-8.48,4.89a2.71,2.71,0,0,1-2.26.1l-8.59-4a2.88,2.88,0,0,0-1.67-.1,49.74,49.74,0,0,1-6.73,1.6,1.2,1.2,0,0,0-.9.88l-1.08,5.66A1.73,1.73,0,0,1,350.21,413.25Zm-23.5-10.43a3.28,3.28,0,0,1,.91.12,50.84,50.84,0,0,0,6.62,1.57,2.07,2.07,0,0,1,1.58,1.54l1.07,5.67a.92.92,0,0,0,.85.7h12.47a.93.93,0,0,0,.85-.7l1.07-5.67a2.06,2.06,0,0,1,1.58-1.54,51.23,51.23,0,0,0,6.62-1.57,3.53,3.53,0,0,1,2.27.14l8.59,4a1.84,1.84,0,0,0,1.49-.07l8.48-4.89c.12-.07.19-.15.19-.22s-.06-.15-.16-.23l-6.72-4.84a1.32,1.32,0,0,1-.56-.93,1.37,1.37,0,0,1,.37-1.07,16.68,16.68,0,0,0,2.34-3.24,2.47,2.47,0,0,1,1.86-1.23l11.3-.72a.73.73,0,0,0,.67-.71v-6.3a.73.73,0,0,0-.67-.71l-11.3-.72a2.48,2.48,0,0,1-1.86-1.23,16.68,16.68,0,0,0-2.34-3.24,1.34,1.34,0,0,1-.37-1.06,1.32,1.32,0,0,1,.56-.94l6.72-4.84c.1-.07.17-.16.16-.23s-.07-.15-.19-.21l-8.48-4.9a1.88,1.88,0,0,0-1.49-.07l-8.59,4a3.53,3.53,0,0,1-2.27.14,50.84,50.84,0,0,0-6.62-1.57,2.06,2.06,0,0,1-1.58-1.54l-1.08-5.66a.91.91,0,0,0-.84-.71H337.74a.93.93,0,0,0-.85.71l-1.07,5.66a2.06,2.06,0,0,1-1.58,1.54,50.84,50.84,0,0,0-6.62,1.57,3.59,3.59,0,0,1-2.27-.13l-8.59-4a1.91,1.91,0,0,0-1.5.07l-8.47,4.9c-.12.06-.19.14-.19.21s0,.16.16.23l6.72,4.84a1.32,1.32,0,0,1,.56.94,1.34,1.34,0,0,1-.37,1.06,16.68,16.68,0,0,0-2.34,3.24,2.48,2.48,0,0,1-1.87,1.23l-11.29.72a.73.73,0,0,0-.67.71v6.3a.72.72,0,0,0,.66.71l11.3.72a2.48,2.48,0,0,1,1.87,1.23,16.68,16.68,0,0,0,2.34,3.24,1.37,1.37,0,0,1,.37,1.07,1.32,1.32,0,0,1-.56.93l-6.72,4.84c-.1.08-.17.16-.16.23s.07.15.19.22l8.47,4.89a1.87,1.87,0,0,0,1.5.07l8.59-4A3.4,3.4,0,0,1,326.71,402.82Zm17.26-5a29.65,29.65,0,0,1-14.53-3.47c-4-2.28-6.14-5.35-6.14-8.63s2.18-6.34,6.14-8.63c8-4.62,21.06-4.63,29.07,0,4,2.29,6.14,5.35,6.14,8.63s-2.18,6.35-6.14,8.63A29.66,29.66,0,0,1,344,397.86Zm0-23.38a28.81,28.81,0,0,0-14.11,3.37c-3.69,2.13-5.73,4.94-5.73,7.91s2,5.78,5.73,7.91c7.78,4.5,20.45,4.5,28.23,0,3.69-2.13,5.73-4.94,5.73-7.91s-2-5.78-5.73-7.91A28.82,28.82,0,0,0,344,374.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.94,449.65l-8-.83a4.19,4.19,0,0,1-3.73-4.69l.24-2c-.91-.31-1.79-.65-2.62-1a2.61,2.61,0,0,0-.62-.07L243.17,443a5,5,0,0,1-1.51.22,5.65,5.65,0,0,1-3.55-1.22l-4-3.32a3.67,3.67,0,0,1,.71-6.23l3.78-1.9a1.42,1.42,0,0,0-.05-.16l-6.31-1.08a4,4,0,0,1-3.19-5.2l1.09-3.46a4.8,4.8,0,0,1,4.61-3.25l7,.29a1.11,1.11,0,0,0,.31-.14l.68-.67-1.67-1.78a3.7,3.7,0,0,1,1.35-6.1l6.25-2.51a5.27,5.27,0,0,1,2-.36,5.67,5.67,0,0,1,3.11.89l4.15,2.76a1.54,1.54,0,0,0,.52.1c1.39-.24,2.83-.42,4.14-.52l1.46-2.84a5,5,0,0,1,4.37-2.64h.31l8,.83a4.19,4.19,0,0,1,3.74,4.69l-.24,2c.91.31,1.79.65,2.62,1a2.07,2.07,0,0,0,.62.07l6.08-1.91a5,5,0,0,1,1.51-.22,5.73,5.73,0,0,1,3.55,1.22l4,3.32a3.66,3.66,0,0,1-.72,6.23l-3.78,1.9a1,1,0,0,1,.05.16l6.32,1.08a4,4,0,0,1,3.18,5.2l-1.08,3.46a4.81,4.81,0,0,1-4.62,3.26l-7-.3a1.11,1.11,0,0,0-.31.14c-.22.22-.45.45-.69.67l1.68,1.78a3.7,3.7,0,0,1-1.35,6.1L284,447.05a5.23,5.23,0,0,1-2,.36,5.74,5.74,0,0,1-3.1-.88l-4.15-2.76a1.35,1.35,0,0,0-.52-.11c-1.39.24-2.83.42-4.14.52L268.63,447a5,5,0,0,1-4.37,2.64Zm-5.06-27.35c-2.62,1.05-4.38,2.63-4.62,4.12-.2,1.27.77,2.37,1.62,3.08,2.26,1.88,6.27,3.05,10.47,3.05a20.33,20.33,0,0,0,7.45-1.33c2.61-1.05,4.38-2.63,4.62-4.12.2-1.27-.77-2.37-1.62-3.08-2.26-1.88-6.28-3-10.48-3A20.28,20.28,0,0,0,258.88,422.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,408.06a1.71,1.71,0,0,1-1.17-1.77l.36-3a1.36,1.36,0,0,0-1.22-1.52l-7.82-.82a2.18,2.18,0,0,0-2,1.09l-1.56,3a2.75,2.75,0,0,1-2,1.32c-1.37.1-2.72.27-4.05.5a4,4,0,0,1-2.53-.51l-4.2-2.79a3,3,0,0,0-2.45-.25l-6.26,2.5a.92.92,0,0,0-.64.8h0v.07h0v6.39h0a1,1,0,0,0,.31.7l.36.39a3.32,3.32,0,0,1-1.72.53l-7.14-.29a1.92,1.92,0,0,0-1.81,1.27l-1.08,3.46a1.07,1.07,0,0,0,0,.43h0v6.45h0a1.17,1.17,0,0,0,1,1.13l5.54,1-2.16,1.08a.9.9,0,0,0-.56.78h0v6.46h0a1,1,0,0,0,.39.71l4,3.32a2.85,2.85,0,0,0,2.4.48l6.08-1.91a4.26,4.26,0,0,1,2.59.17,32.22,32.22,0,0,0,3.26,1.2,1.63,1.63,0,0,1,.8.57v4.35h0a1.36,1.36,0,0,0,1.22,1.34l7.82.82a2.19,2.19,0,0,0,2-1.1l1.56-3a2.73,2.73,0,0,1,2-1.32c1.36-.1,2.72-.27,4.05-.5a4,4,0,0,1,2.52.5l4.21,2.8a3,3,0,0,0,2.45.25l6.25-2.51a.9.9,0,0,0,.65-.83h0v-6.44h0a1,1,0,0,0-.31-.69l-.36-.39a3.17,3.17,0,0,1,1.72-.53L298,434a1.88,1.88,0,0,0,1.8-1.27l1.09-3.45a1.41,1.41,0,0,0,0-.4h0v-6.42h0a1.15,1.15,0,0,0-1-1.19l-5.54-.95,2.16-1.08a.89.89,0,0,0,.56-.8h0v-6.42h0a1,1,0,0,0-.39-.74l-4-3.33a2.86,2.86,0,0,0-2.4-.47l-6.09,1.91a4.3,4.3,0,0,1-2.58-.17A32.22,32.22,0,0,0,278.43,408.06Zm-25.94,16.19a11.54,11.54,0,0,1,5.33-3.86c6.78-2.72,16.09-1.75,20.79,2.17a8.8,8.8,0,0,1,1.59,1.68,11.58,11.58,0,0,1-5.35,3.88c-6.78,2.72-16.08,1.74-20.79-2.17A8.52,8.52,0,0,1,252.49,424.25Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.43,408.06a1.71,1.71,0,0,1-1.17-1.77l.36-3a1.36,1.36,0,0,0-1.22-1.52l-7.82-.82a2.18,2.18,0,0,0-2,1.09l-1.56,3a2.75,2.75,0,0,1-2,1.32c-1.37.1-2.72.27-4.05.5a4,4,0,0,1-2.53-.51l-4.2-2.79a3,3,0,0,0-2.45-.25l-6.26,2.5a.92.92,0,0,0-.64.8h0v.07h0v6.39h0a1,1,0,0,0,.31.7l.36.39a3.32,3.32,0,0,1-1.72.53l-7.14-.29a1.92,1.92,0,0,0-1.81,1.27l-1.08,3.46a1.07,1.07,0,0,0,0,.43h0v6.45h0a1.17,1.17,0,0,0,1,1.13l5.54,1-2.16,1.08a.9.9,0,0,0-.56.78h0v6.46h0a1,1,0,0,0,.39.71l4,3.32a2.85,2.85,0,0,0,2.4.48l6.08-1.91a4.26,4.26,0,0,1,2.59.17,32.22,32.22,0,0,0,3.26,1.2,1.63,1.63,0,0,1,.8.57v4.35h0a1.36,1.36,0,0,0,1.22,1.34l7.82.82a2.19,2.19,0,0,0,2-1.1l1.56-3a2.73,2.73,0,0,1,2-1.32c1.36-.1,2.72-.27,4.05-.5a4,4,0,0,1,2.52.5l4.21,2.8a3,3,0,0,0,2.45.25l6.25-2.51a.9.9,0,0,0,.65-.83h0v-6.44h0a1,1,0,0,0-.31-.69l-.36-.39a3.17,3.17,0,0,1,1.72-.53L298,434a1.88,1.88,0,0,0,1.8-1.27l1.09-3.45a1.41,1.41,0,0,0,0-.4h0v-6.42h0a1.15,1.15,0,0,0-1-1.19l-5.54-.95,2.16-1.08a.89.89,0,0,0,.56-.8h0v-6.42h0a1,1,0,0,0-.39-.74l-4-3.33a2.86,2.86,0,0,0-2.4-.47l-6.09,1.91a4.3,4.3,0,0,1-2.58-.17A32.22,32.22,0,0,0,278.43,408.06Zm-25.94,16.19a11.54,11.54,0,0,1,5.33-3.86c6.78-2.72,16.09-1.75,20.79,2.17a8.8,8.8,0,0,1,1.59,1.68,11.58,11.58,0,0,1-5.35,3.88c-6.78,2.72-16.08,1.74-20.79-2.17A8.52,8.52,0,0,1,252.49,424.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.18,423.52a2.36,2.36,0,0,0-1.65-1.59l-6.81-1.16a1.16,1.16,0,0,1-1-1.06v6.38a1.18,1.18,0,0,0,1,1.12l5.54,1,2.86-1.44a1.35,1.35,0,0,0,.57-1.84A9,9,0,0,1,241.18,423.52Zm1.67-10.38h0a1,1,0,0,0,.3.7l.36.39a2.85,2.85,0,0,0,.6-.45,15.08,15.08,0,0,1,1.71-1.53,1.21,1.21,0,0,0,.17-1.83l-2.84-3a1,1,0,0,1-.31-.7Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.82,414c-5.84,2.34-7.91,6.66-5.33,10.31a11.5,11.5,0,0,1,5.33-3.87c6.78-2.72,16.09-1.75,20.8,2.17a8.65,8.65,0,0,1,1.57,1.68c1.82-2.59,1.4-5.65-1.57-8.12C273.91,412.2,264.61,411.24,257.82,414Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,436.21a2.29,2.29,0,0,0-.65.75l-1.56,3a2.2,2.2,0,0,1-1.15,1v6.44a2.1,2.1,0,0,0,1.15-1l1.57-3a2.29,2.29,0,0,1,.66-.74Zm21.51-.85h0a.91.91,0,0,1-.65.84l-6.25,2.5a2.83,2.83,0,0,1-1.64.07v6.43a2.83,2.83,0,0,0,1.64-.06l6.26-2.51a.88.88,0,0,0,.64-.83Zm-41.51-2.7-6,1.89a2.78,2.78,0,0,1-1.51,0v6.42a2.64,2.64,0,0,0,1.52,0l6-1.88ZM301,422.48a1.8,1.8,0,0,1-.07.38l-1.07,3.46a1.93,1.93,0,0,1-1.81,1.27l-7.14-.29a2.92,2.92,0,0,0-1.12.23V434a3,3,0,0,1,1.11-.22L298,434a1.9,1.9,0,0,0,1.8-1.26l1.08-3.46a1.14,1.14,0,0,0,.06-.4Zm-3.82-10.42a.59.59,0,0,1,0,.22.69.69,0,0,1-.22.33,1.54,1.54,0,0,1-.31.22l-5,2.52a.87.87,0,0,0-.3.22,1.18,1.18,0,0,0-.34.52,1.38,1.38,0,0,0-.08.5l0,.26a3.4,3.4,0,0,0,.12.34,8.87,8.87,0,0,1,.51,1.35,2.35,2.35,0,0,0,1.66,1.6l1.26.21,2.16-1.08a.91.91,0,0,0,.57-.8h0Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.32,436.21a2.29,2.29,0,0,0-.65.75l-1.56,3a2.2,2.2,0,0,1-1.15,1v6.44a2.1,2.1,0,0,0,1.15-1l1.57-3a2.29,2.29,0,0,1,.66-.74Zm21.51-.85h0a.91.91,0,0,1-.65.84l-6.25,2.5a2.83,2.83,0,0,1-1.64.07v6.43a2.83,2.83,0,0,0,1.64-.06l6.26-2.51a.88.88,0,0,0,.64-.83Zm-41.51-2.7-6,1.89a2.78,2.78,0,0,1-1.51,0v6.42a2.64,2.64,0,0,0,1.52,0l6-1.88ZM301,422.48a1.8,1.8,0,0,1-.07.38l-1.07,3.46a1.93,1.93,0,0,1-1.81,1.27l-7.14-.29a2.92,2.92,0,0,0-1.12.23V434a3,3,0,0,1,1.11-.22L298,434a1.9,1.9,0,0,0,1.8-1.26l1.08-3.46a1.14,1.14,0,0,0,.06-.4Zm-3.82-10.42a.59.59,0,0,1,0,.22.69.69,0,0,1-.22.33,1.54,1.54,0,0,1-.31.22l-5,2.52a.87.87,0,0,0-.3.22,1.18,1.18,0,0,0-.34.52,1.38,1.38,0,0,0-.08.5l0,.26a3.4,3.4,0,0,0,.12.34,8.87,8.87,0,0,1,.51,1.35,2.35,2.35,0,0,0,1.66,1.6l1.26.21,2.16-1.08a.91.91,0,0,0,.57-.8h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36,407.52l-6.09,1.91a4.3,4.3,0,0,1-2.58-.17,32.22,32.22,0,0,0-3.26-1.2,1.71,1.71,0,0,1-1.17-1.77l.36-3a1.36,1.36,0,0,0-1.22-1.52l-7.82-.82a2.18,2.18,0,0,0-2,1.09l-1.56,3a2.75,2.75,0,0,1-2,1.32c-1.37.1-2.72.27-4.05.5a4,4,0,0,1-2.53-.51l-4.2-2.79a3,3,0,0,0-2.45-.25l-6.26,2.5a.89.89,0,0,0-.34,1.53l2.84,3a1.21,1.21,0,0,1-.17,1.83,16,16,0,0,0-1.71,1.53,3.51,3.51,0,0,1-2.32,1l-7.14-.29a1.92,1.92,0,0,0-1.81,1.27l-1.08,3.46a1.18,1.18,0,0,0,.95,1.56l6.8,1.16a2.33,2.33,0,0,1,1.66,1.6,10.61,10.61,0,0,0,.51,1.35,1.35,1.35,0,0,1-.57,1.84l-5,2.52a.84.84,0,0,0-.17,1.51l4,3.33a2.85,2.85,0,0,0,2.4.47l6.08-1.91a4.34,4.34,0,0,1,2.59.17,32.22,32.22,0,0,0,3.26,1.2,1.72,1.72,0,0,1,1.17,1.77l-.36,3a1.36,1.36,0,0,0,1.22,1.52l7.81.82a2.19,2.19,0,0,0,2-1.09l1.56-3a2.75,2.75,0,0,1,2-1.32c1.36-.1,2.72-.27,4.05-.5a4,4,0,0,1,2.52.51l4.21,2.79a3,3,0,0,0,2.45.25l6.25-2.5a.88.88,0,0,0,.34-1.53l-2.83-3a1.2,1.2,0,0,1,.17-1.83,16,16,0,0,0,1.71-1.53,3.5,3.5,0,0,1,2.31-1l7.15.29a1.91,1.91,0,0,0,1.8-1.27l1.09-3.46a1.18,1.18,0,0,0-1-1.56l-6.8-1.16a2.35,2.35,0,0,1-1.66-1.6,9.29,9.29,0,0,0-.51-1.35,1.36,1.36,0,0,1,.58-1.84l5-2.52a.84.84,0,0,0,.18-1.51l-4-3.33A2.86,2.86,0,0,0,290.36,407.52Zm-11.75,8.6c4.71,3.91,3,9.29-3.76,12s-16.08,1.74-20.79-2.17-3-9.29,3.76-12S273.91,412.2,278.61,416.12Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.36,407.52l-6.09,1.91a4.3,4.3,0,0,1-2.58-.17,32.22,32.22,0,0,0-3.26-1.2,1.71,1.71,0,0,1-1.17-1.77l.36-3a1.36,1.36,0,0,0-1.22-1.52l-7.82-.82a2.18,2.18,0,0,0-2,1.09l-1.56,3a2.75,2.75,0,0,1-2,1.32c-1.37.1-2.72.27-4.05.5a4,4,0,0,1-2.53-.51l-4.2-2.79a3,3,0,0,0-2.45-.25l-6.26,2.5a.89.89,0,0,0-.34,1.53l2.84,3a1.21,1.21,0,0,1-.17,1.83,16,16,0,0,0-1.71,1.53,3.51,3.51,0,0,1-2.32,1l-7.14-.29a1.92,1.92,0,0,0-1.81,1.27l-1.08,3.46a1.18,1.18,0,0,0,.95,1.56l6.8,1.16a2.33,2.33,0,0,1,1.66,1.6,10.61,10.61,0,0,0,.51,1.35,1.35,1.35,0,0,1-.57,1.84l-5,2.52a.84.84,0,0,0-.17,1.51l4,3.33a2.85,2.85,0,0,0,2.4.47l6.08-1.91a4.34,4.34,0,0,1,2.59.17,32.22,32.22,0,0,0,3.26,1.2,1.72,1.72,0,0,1,1.17,1.77l-.36,3a1.36,1.36,0,0,0,1.22,1.52l7.81.82a2.19,2.19,0,0,0,2-1.09l1.56-3a2.75,2.75,0,0,1,2-1.32c1.36-.1,2.72-.27,4.05-.5a4,4,0,0,1,2.52.51l4.21,2.79a3,3,0,0,0,2.45.25l6.25-2.5a.88.88,0,0,0,.34-1.53l-2.83-3a1.2,1.2,0,0,1,.17-1.83,16,16,0,0,0,1.71-1.53,3.5,3.5,0,0,1,2.31-1l7.15.29a1.91,1.91,0,0,0,1.8-1.27l1.09-3.46a1.18,1.18,0,0,0-1-1.56l-6.8-1.16a2.35,2.35,0,0,1-1.66-1.6,9.29,9.29,0,0,0-.51-1.35,1.36,1.36,0,0,1,.58-1.84l5-2.52a.84.84,0,0,0,.18-1.51l-4-3.33A2.86,2.86,0,0,0,290.36,407.52Zm-11.75,8.6c4.71,3.91,3,9.29-3.76,12s-16.08,1.74-20.79-2.17-3-9.29,3.76-12S273.91,412.2,278.61,416.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.26,441.64H264l-7.82-.81a1.93,1.93,0,0,1-1.3-.71,1.89,1.89,0,0,1-.4-1.43l.36-3a1.19,1.19,0,0,0-.79-1.18,29.56,29.56,0,0,1-3.32-1.22,3.82,3.82,0,0,0-2.21-.15l-6.08,1.91a3.44,3.44,0,0,1-2.91-.57l-4-3.33a1.47,1.47,0,0,1-.59-1.29,1.49,1.49,0,0,1,.87-1.13l5-2.52a.82.82,0,0,0,.32-1.12,10,10,0,0,1-.54-1.43,1.8,1.8,0,0,0-1.23-1.21l-6.8-1.16a1.73,1.73,0,0,1-1.38-2.26l1.08-3.46a2.47,2.47,0,0,1,2.35-1.65l7.15.28a2.89,2.89,0,0,0,1.89-.82,19.39,19.39,0,0,1,1.77-1.57.78.78,0,0,0,.31-.52.67.67,0,0,0-.2-.5l-2.83-3a1.42,1.42,0,0,1,.53-2.41l6.25-2.51a3.53,3.53,0,0,1,3,.3l4.2,2.8a3.47,3.47,0,0,0,2.13.42c1.34-.23,2.72-.4,4.1-.51a2.17,2.17,0,0,0,1.58-1l1.56-3a2.75,2.75,0,0,1,2.56-1.38l7.82.81a1.91,1.91,0,0,1,1.7,2.14l-.36,3a1.16,1.16,0,0,0,.79,1.17,32.53,32.53,0,0,1,3.32,1.23,3.79,3.79,0,0,0,2.2.15L290.2,407a3.41,3.41,0,0,1,2.9.57l4,3.33a1.46,1.46,0,0,1,.58,1.29,1.48,1.48,0,0,1-.86,1.13l-5,2.52a.82.82,0,0,0-.32,1.12,10,10,0,0,1,.54,1.43,1.8,1.8,0,0,0,1.23,1.21l6.79,1.16a1.77,1.77,0,0,1,1.23.81,1.75,1.75,0,0,1,.16,1.45l-1.08,3.46a2.49,2.49,0,0,1-2.35,1.65l-7.15-.28a3,3,0,0,0-1.9.81,16.86,16.86,0,0,1-1.76,1.58.74.74,0,0,0-.31.52.66.66,0,0,0,.19.5l2.84,3a1.42,1.42,0,0,1-.53,2.41l-6.26,2.51a3.52,3.52,0,0,1-2.95-.31L276,436.1a3.44,3.44,0,0,0-2.13-.42c-1.33.23-2.71.4-4.1.51a2.21,2.21,0,0,0-1.58,1l-1.55,3A2.76,2.76,0,0,1,264.26,441.64ZM249.38,432a4.7,4.7,0,0,1,1.83.34,31.67,31.67,0,0,0,3.2,1.18,2.26,2.26,0,0,1,1.55,2.35l-.36,3a.86.86,0,0,0,.17.61.8.8,0,0,0,.56.31l7.82.81a1.64,1.64,0,0,0,1.47-.79l1.56-3a3.28,3.28,0,0,1,2.47-1.61c1.35-.1,2.69-.27,4-.5a4.47,4.47,0,0,1,2.92.59l4.2,2.79a2.42,2.42,0,0,0,2,.2l6.25-2.5c.17-.07.28-.17.3-.27a.42.42,0,0,0-.16-.38l-2.83-3a1.73,1.73,0,0,1-.49-1.33,1.83,1.83,0,0,1,.72-1.3,16,16,0,0,0,1.66-1.48,4.11,4.11,0,0,1,2.73-1.15L298,427a1.4,1.4,0,0,0,1.26-.89l1.09-3.45a.67.67,0,0,0-.06-.56.63.63,0,0,0-.47-.3l-6.8-1.17a2.83,2.83,0,0,1-2.09-2,10.45,10.45,0,0,0-.48-1.28,1.89,1.89,0,0,1,.82-2.56l5-2.52a.46.46,0,0,0,.27-.27.45.45,0,0,0-.2-.33l-4-3.33a2.35,2.35,0,0,0-1.89-.37L284.44,410a4.82,4.82,0,0,1-3-.19,30.21,30.21,0,0,0-3.2-1.18,2.26,2.26,0,0,1-1.56-2.35l.36-3a.81.81,0,0,0-.17-.62.78.78,0,0,0-.56-.3l-7.81-.82a1.67,1.67,0,0,0-1.48.8l-1.55,3A3.28,3.28,0,0,1,263,407a40.09,40.09,0,0,0-4,.5,4.47,4.47,0,0,1-2.92-.59l-4.21-2.79a2.4,2.4,0,0,0-1.94-.2l-6.25,2.5a.5.5,0,0,0-.31.27.48.48,0,0,0,.16.38l2.84,3a1.76,1.76,0,0,1,.49,1.33,1.81,1.81,0,0,1-.73,1.3,17,17,0,0,0-1.65,1.48,4.08,4.08,0,0,1-2.73,1.15l-7.14-.29a1.39,1.39,0,0,0-1.27.89l-1.08,3.45a.72.72,0,0,0,.05.56.66.66,0,0,0,.48.3l6.79,1.17a2.86,2.86,0,0,1,2.1,2,9,9,0,0,0,.48,1.28,1.9,1.9,0,0,1-.82,2.56l-5,2.52c-.16.08-.26.18-.27.27a.42.42,0,0,0,.2.33l4,3.32a2.3,2.3,0,0,0,1.88.38l6.09-1.91A4,4,0,0,1,249.38,432Zm17-1.77c-4.87,0-9.68-1.34-12.67-3.83-2.15-1.79-3.14-4-2.79-6.2.43-2.75,2.87-5.2,6.7-6.73,6.94-2.78,16.51-1.76,21.34,2.26,2.15,1.79,3.15,4,2.8,6.2-.44,2.74-2.88,5.2-6.7,6.73A23.67,23.67,0,0,1,266.38,430.2Zm0-17.25a22.54,22.54,0,0,0-8.31,1.51c-3.46,1.38-5.66,3.53-6,5.88-.29,1.84.54,3.63,2.41,5.19,4.56,3.79,13.64,4.73,20.24,2.08,3.46-1.38,5.65-3.53,6-5.88.29-1.84-.55-3.64-2.42-5.19h0C275.46,414.2,270.94,413,266.34,413Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flags--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flag--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.33,48.85l0,46c0,.48,1.23.5,1.25,0l0-45.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.79,49.09a.84.84,0,1,1-.65-1A.84.84,0,0,1,354.79,49.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.33,49.45c-3.86,4.61-9.34,2.55-13.86,2.28-4.89-.29-7.87,1.29-9.36,3.44,1.42-.38,5.38,0,6.63,1,0,0-5,3.26-5,8.61,1.45-2.27,4-4,8.86-3,4.29.89,9.72,2.86,12.7-.44Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.56,61.38c-3.94,1.2-14.69-4-16.81,3.41,1.45-2.27,4-4,8.86-3,4.29.89,9.72,2.86,12.7-.44l0-11.93C353.31,54.15,352.5,60.19,348.56,61.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.33,54l.68,2.06,2.15.29a.15.15,0,0,1,.07.26l-1.75,1.28.38,2.14a.14.14,0,0,1-.22.14l-1.76-1.27-1.91,1a.15.15,0,0,1-.21-.17l.66-2.07-1.57-1.5a.15.15,0,0,1,.1-.25h2.17l.94-2A.14.14,0,0,1,345.33,54Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flag--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.39,86.32l-.07,60.58c0,.64,1.63.67,1.66,0L313,86.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.31,86.64a1.12,1.12,0,1,1-.86-1.32A1.12,1.12,0,0,1,313.31,86.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.38,87.11c-5.09,6.07-12.31,3.36-18.26,3-6.45-.39-10.38,1.69-12.33,4.52,1.86-.49,7.08,0,8.73,1.34,0,0-6.57,4.3-6.58,11.34,1.91-3,5.24-5.23,11.68-3.91,5.65,1.17,12.81,3.77,16.74-.59Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.09,102.83c-5.19,1.58-19.36-5.33-22.15,4.49,1.91-3,5.24-5.23,11.68-3.91,5.65,1.17,12.81,3.77,16.74-.59l0-15.71C311.36,93.3,310.29,101.26,305.09,102.83Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flag--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.83,123.79,254.75,199c0,.79,2,.82,2.05,0l.09-75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.22,124.18a1.38,1.38,0,1,1-2.7-.57,1.37,1.37,0,0,1,1.63-1.06A1.38,1.38,0,0,1,257.22,124.18Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.82,124.77c-6.31,7.54-15.27,4.17-22.66,3.73-8-.48-12.88,2.11-15.3,5.62,2.31-.62,8.79,0,10.84,1.66,0,0-8.16,5.33-8.17,14.07,2.37-3.7,6.5-6.49,14.49-4.85,7,1.45,15.91,4.67,20.78-.73Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,144.28c-6.45,2-24-6.61-27.49,5.57,2.37-3.7,6.5-6.49,14.49-4.85,7,1.45,15.91,4.67,20.78-.73l0-19.5C254.8,132.45,253.47,142.33,247,144.28Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--flag--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.74,162.21l-.1,89.8c0,.93,2.42,1,2.45,0l.1-89.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.58,162.68a1.65,1.65,0,1,1-1.27-2A1.65,1.65,0,0,1,198.58,162.68Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.73,163.38c-7.55,9-18.25,5-27.07,4.45-9.56-.57-15.38,2.52-18.28,6.71,2.76-.73,10.51,0,13,2,0,0-9.74,6.37-9.75,16.8,2.83-4.42,7.76-7.75,17.3-5.79,8.39,1.73,19,5.58,24.82-.87Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.41,186.68c-7.7,2.34-28.7-7.9-32.83,6.65,2.83-4.42,7.76-7.75,17.3-5.79,8.39,1.73,19,5.58,24.82-.87l0-23.29C195.69,172.55,194.11,184.35,186.41,186.68Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coin--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coin--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.65,34.2l-1-2.12,4.43-2.55h0a6.64,6.64,0,0,1,1.67-.7l.62-.14a8.47,8.47,0,0,1,3.12.09c.37.08.74.18,1.12.3a12,12,0,0,1,1.16.45,14.11,14.11,0,0,1,1.5.76c.52.31,1,.65,1.55,1s.77.58,1.14.9c5.5,4.64,9.83,12.92,10.92,20.87q.12.83.18,1.62c.07.77.1,1.54.1,2.29s0,1.21-.08,1.79-.09,1-.16,1.45-.16.91-.27,1.35h0A12.93,12.93,0,0,1,407.36,65c-.12.21-.24.42-.37.62a8.19,8.19,0,0,1-2,2.12,6.84,6.84,0,0,1-.72.47h0l-4.19,2.42-.92-1.94a6.87,6.87,0,0,1-.75-.19,13.54,13.54,0,0,1-2.91-1.29,18.14,18.14,0,0,1-1.71-1.14,23.27,23.27,0,0,1-2.11-1.79,35.68,35.68,0,0,1-9.53-18.21c-.19-1-.34-2-.43-3.05-.07-.85-.11-1.68-.11-2.51a21,21,0,0,1,.29-3.56A15.21,15.21,0,0,1,382.65,34.2Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.86,48.38l-9,5.19-1.19-3.42,9-5.2A35.54,35.54,0,0,1,407.86,48.38Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.07,29.53h0a6.64,6.64,0,0,1,1.67-.7l.62-.14a8.47,8.47,0,0,1,3.12.09l.41.1-9.25,5.34v0l-1-2.12Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,42.65l-1.18-1.42,13.48-7.76c.42.42.84.87,1.25,1.34Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.44,38.62l-11.67,6.74L390.48,42l10.88-6.28A32.9,32.9,0,0,1,403.44,38.62Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.07,29.53h0a6.64,6.64,0,0,1,1.67-.7l.62-.14a8.47,8.47,0,0,1,3.12.09c.37.08.74.18,1.12.3a12,12,0,0,1,1.16.45,14.11,14.11,0,0,1,1.5.76c.52.31,1,.65,1.55,1s.77.58,1.14.9c5.12,4.32,9.23,11.8,10.65,19.23L389.85,62.27a36.62,36.62,0,0,1-7.67-16.21c-.19-1-.34-2-.43-3.05-.07-.85-.11-1.68-.11-2.51a21,21,0,0,1,.29-3.56,15.21,15.21,0,0,1,.72-2.74l-1-2.12Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.11,70.62l-.92-1.94a6.87,6.87,0,0,1-.75-.19,13.54,13.54,0,0,1-2.91-1.29,18.14,18.14,0,0,1-1.71-1.14,23.27,23.27,0,0,1-2.11-1.79c-.64-.62-1.26-1.29-1.86-2L408.6,51.44c.11.55.2,1.1.27,1.64s.14,1.09.18,1.62c.07.77.1,1.54.1,2.29s0,1.21-.08,1.79-.09,1-.16,1.45-.16.91-.27,1.35h0A12.93,12.93,0,0,1,407.36,65c-.12.21-.24.42-.37.62a8.19,8.19,0,0,1-2,2.12,6.84,6.84,0,0,1-.72.47h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.36,65c-.12.21-.24.42-.37.62a8.19,8.19,0,0,1-2,2.12,6.84,6.84,0,0,1-.72.47h0l-4.19,2.42-.92-1.94h0l-.07-.79,9.32-5.38A12.84,12.84,0,0,1,407.36,65Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.9,43.23c0,.83,0,1.67.11,2.51a30.06,30.06,0,0,0,.44,3.06A35.58,35.58,0,0,0,387,67a20.34,20.34,0,0,0,2.1,1.79,18.14,18.14,0,0,0,1.71,1.14,13.39,13.39,0,0,0,2.92,1.29,9,9,0,0,0,3.09.41,7,7,0,0,0,3.88-1.39,8.33,8.33,0,0,0,2-2.12c.13-.2.25-.41.37-.62a13.3,13.3,0,0,0,1.29-3.41h0c.1-.43.19-.88.26-1.35s.13-1,.17-1.45.07-1.17.07-1.79,0-1.52-.09-2.29q-.07-.8-.18-1.62c-1.1-8-5.43-16.23-10.93-20.87-.37-.32-.75-.61-1.14-.9s-1-.71-1.55-1a14,14,0,0,0-1.49-.76,12,12,0,0,0-1.16-.45c-.38-.12-.76-.22-1.13-.3a8.25,8.25,0,0,0-3.12-.08c-.21,0-.41.08-.62.13A7.15,7.15,0,0,0,381,32.55a9.06,9.06,0,0,0-2.72,3.6,15,15,0,0,0-1,3.53A23,23,0,0,0,376.9,43.23Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.9,43.23c0,.83,0,1.67.11,2.51a30.06,30.06,0,0,0,.44,3.06A35.58,35.58,0,0,0,387,67a20.34,20.34,0,0,0,2.1,1.79,18.14,18.14,0,0,0,1.71,1.14,13.39,13.39,0,0,0,2.92,1.29,9,9,0,0,0,3.09.41,7,7,0,0,0,3.88-1.39,8.33,8.33,0,0,0,2-2.12c.13-.2.25-.41.37-.62a13.3,13.3,0,0,0,1.29-3.41h0c.1-.43.19-.88.26-1.35s.13-1,.17-1.45.07-1.17.07-1.79,0-1.52-.09-2.29q-.07-.8-.18-1.62c-1.1-8-5.43-16.23-10.93-20.87-.37-.32-.75-.61-1.14-.9s-1-.71-1.55-1a14,14,0,0,0-1.49-.76,12,12,0,0,0-1.16-.45c-.38-.12-.76-.22-1.13-.3a8.25,8.25,0,0,0-3.12-.08c-.21,0-.41.08-.62.13A7.15,7.15,0,0,0,381,32.55a9.06,9.06,0,0,0-2.72,3.6,15,15,0,0,0-1,3.53A23,23,0,0,0,376.9,43.23Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.25,53.94c.11.55.2,1.1.28,1.65s.13,1.09.18,1.62c.06.77.09,1.54.09,2.29s0,1.21-.07,1.79-.1,1-.17,1.45-.16.92-.26,1.35h0A13.3,13.3,0,0,1,403,67.5c-.12.21-.24.42-.37.62a8.33,8.33,0,0,1-2,2.12,7,7,0,0,1-3.88,1.39,9,9,0,0,1-3.09-.41,13.39,13.39,0,0,1-2.92-1.29,18.07,18.07,0,0,1-1.52-1Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,65.05a12.44,12.44,0,0,1-1,2.45c-.12.21-.24.42-.37.62a8.33,8.33,0,0,1-2,2.12,7,7,0,0,1-3.14,1.31Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.35,47.47c.44,1.12.83,2.27,1.17,3.42L387.2,67.21,387,67a24.34,24.34,0,0,1-2-2.16Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,38.23a33,33,0,0,1,2.09,2.9l-18,18a36.23,36.23,0,0,1-1.6-3.39Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,36c.43.42.86.87,1.27,1.34L379.07,54.5c-.24-.65-.47-1.29-.67-2Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.94,42h0c0-.33.05-.65.08-1l0-.32c0-.11,0-.22,0-.32s.07-.47.1-.7a15,15,0,0,1,1-3.53,9.06,9.06,0,0,1,2.72-3.6,7,7,0,0,1,2.44-1.21c.21-.05.41-.1.62-.13a8.25,8.25,0,0,1,3.12.08l.42.1Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.46,45.37c0,7.34,4.28,15.82,9.69,19.42l.7.44c5.74,3.31,10.39-.21,10.39-7.86s-4.65-16.55-10.39-19.86a7.88,7.88,0,0,0-.7-.37C384.74,34.49,380.46,38,380.46,45.37Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.46,45.37c0,7.34,4.28,15.82,9.69,19.42l.7.44c5.74,3.31,10.39-.21,10.39-7.86s-4.65-16.55-10.39-19.86a7.88,7.88,0,0,0-.7-.37C384.74,34.49,380.46,38,380.46,45.37Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.92,45.63c0,.24,0,.48,0,.72.27,6.84,4.25,14.51,9.26,17.84l.13.09c.18.12.35.23.53.33A8.75,8.75,0,0,0,394,65.75a5.28,5.28,0,0,0,5.49-2.8,10.79,10.79,0,0,0,1.28-4.73c0-.36,0-.73,0-1.12s0-.7,0-1.06a21.8,21.8,0,0,0-.25-2.25,25.17,25.17,0,0,0-7.29-13.92,14,14,0,0,0-1.58-1.25c-.26-.18-.52-.34-.78-.49l-.66-.36-.19-.09a6.71,6.71,0,0,0-4.11-.65c-2.09.4-3.7,2.07-4.47,4.73A13.76,13.76,0,0,0,380.92,45.63Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.92,45.63c0,.24,0,.48,0,.72.27,6.84,4.25,14.51,9.26,17.84l.13.09c.18.12.35.23.53.33A8.75,8.75,0,0,0,394,65.75a5.28,5.28,0,0,0,5.49-2.8,10.79,10.79,0,0,0,1.28-4.73c0-.36,0-.73,0-1.12s0-.7,0-1.06a21.8,21.8,0,0,0-.25-2.25,25.17,25.17,0,0,0-7.29-13.92,14,14,0,0,0-1.58-1.25c-.26-.18-.52-.34-.78-.49l-.66-.36-.19-.09a6.71,6.71,0,0,0-4.11-.65c-2.09.4-3.7,2.07-4.47,4.73A13.76,13.76,0,0,0,380.92,45.63Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.58,45.39c0-.24,0-.48,0-.71a13.79,13.79,0,0,1,.5-3.88,7.32,7.32,0,0,1,2.13-3.58,4.43,4.43,0,0,1,.69-.19,6.71,6.71,0,0,1,4.11.65l.19.09.66.36c.26.15.52.31.78.49a14,14,0,0,1,1.58,1.25,25.17,25.17,0,0,1,7.29,13.92,21.8,21.8,0,0,1,.25,2.25c0,.36,0,.71,0,1.06s0,.76,0,1.12A10.79,10.79,0,0,1,399.46,63a6.19,6.19,0,0,1-1.31,1.61,5.43,5.43,0,0,1-2.53.23,8.75,8.75,0,0,1-3.12-1.14l-.53-.32-.14-.09C386.83,59.91,382.84,52.23,382.58,45.39Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.58,45.39c0-.24,0-.48,0-.71a13.79,13.79,0,0,1,.5-3.88,7.32,7.32,0,0,1,2.13-3.58,4.43,4.43,0,0,1,.69-.19,6.71,6.71,0,0,1,4.11.65l.19.09.66.36c.26.15.52.31.78.49a14,14,0,0,1,1.58,1.25,25.17,25.17,0,0,1,7.29,13.92,21.8,21.8,0,0,1,.25,2.25c0,.36,0,.71,0,1.06s0,.76,0,1.12A10.79,10.79,0,0,1,399.46,63a6.19,6.19,0,0,1-1.31,1.61,5.43,5.43,0,0,1-2.53.23,8.75,8.75,0,0,1-3.12-1.14l-.53-.32-.14-.09C386.83,59.91,382.84,52.23,382.58,45.39Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,31.21c6-.68,10.89,4.29,14.15,8.76,4.7,6.94,7.69,15.72,6.06,24.12v0a10.56,10.56,0,0,1-3.54,6.17,10.5,10.5,0,0,0,3.69-6.15h0c1.5-6.87-.38-14.1-3.53-20.25C397.47,37.77,391.76,30.38,384,31.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.28,57.2a8.61,8.61,0,0,0-3.13-6.08l.79.2L398.21,50a10.23,10.23,0,0,0-.41-1.45,9.88,9.88,0,0,0-1.18-2.26,12.26,12.26,0,0,0-2.91-2.89l-.09-2.35-2.81-1.62-2.27,1.31,0,.59v.13a2.34,2.34,0,0,0-.56.26l-.17.12c-.27.19-1.57.87-2.1,1.19l-.17.12a2.87,2.87,0,0,0-.87,2.6h0a7.41,7.41,0,0,0,1.14,3.63c.06.09.12.18.17.27l0,0,.19.27.18.23.07.09.14.18a17.92,17.92,0,0,0,1.26,1.34l.6.54-1-.26-2.27,1.31a10.91,10.91,0,0,0,4.28,6.14l.09,2.35,2.84,1.57,2.27-1.31,0-.74a1.44,1.44,0,0,0,.46-.19h0c.35-.22,1.87-1.05,2.26-1.3h0C398,59.47,398.33,58.59,398.28,57.2Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.85,43c.58-.34,1.74-.95,2-1.13l.17-.12a2.34,2.34,0,0,1,.56-.26l.06,1.69A2.73,2.73,0,0,0,385.85,43Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.3,56.68c0,.71-.38,1.06-1.55.42a4.18,4.18,0,0,1-2.2-2.86l-3.4-.85,2.27-1.31,1,.26.06,0c.31.28.62.55.92.8l.36.3a13.16,13.16,0,0,1,1.89,1.74,2.77,2.77,0,0,1,.53.93A1.77,1.77,0,0,1,392.3,56.68Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.6,61.41l0,.73-2.27,1.31-.09-2.35A3.85,3.85,0,0,0,394.6,61.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.35,42.37l-2.81-1.62,2.27-1.31,2.82,1.62.08,2.35a11.94,11.94,0,0,1,2.91,2.9,9.61,9.61,0,0,1,1.18,2.25,10.23,10.23,0,0,1,.41,1.45l-2.27,1.31a10.23,10.23,0,0,0-.41-1.45,9.61,9.61,0,0,0-1.18-2.25,11.94,11.94,0,0,0-2.91-2.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.71,43.41a9.14,9.14,0,0,1,2.55,2.17,7.79,7.79,0,0,1,1.54,3A14.34,14.34,0,0,0,396,45.77a16.06,16.06,0,0,0-1.11-1.22C394.54,44.15,394.12,43.78,393.71,43.41Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.34,59.89h0c-.39.25-1.91,1.08-2.26,1.3.66-.42,1-1.29.94-2.69-.12-3.09-2-5.11-3.92-6.8s-3.43-2.54-3.49-4c0-.94.57-1,1.5-.51a4.65,4.65,0,0,1,2.26,3.22l2.79.72h0a8.64,8.64,0,0,1,3.12,6.08C398.33,58.59,398,59.47,397.34,59.89Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.82 52.93 388.55 54.24 385.15 53.39 387.42 52.08 390.82 52.93",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.82 52.93 388.55 54.24 385.15 53.39 387.42 52.08 390.82 52.93",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.36 63.45 392.27 61.1 394.6 61.4 394.63 62.14 392.36 63.45",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.36 63.45 392.27 61.1 394.6 61.4 394.63 62.14 392.36 63.45",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.56,41.34l.07,1.82a2.72,2.72,0,0,0-2.89-.12l-.17.12a2.87,2.87,0,0,0-.87,2.6h0a7.41,7.41,0,0,0,1.14,3.63c.06.09.12.18.17.27l0,0,.19.27.18.23.07.09.14.18a17.92,17.92,0,0,0,1.26,1.34l.65.59.93.8.36.3a13.16,13.16,0,0,1,1.89,1.74,2.52,2.52,0,0,1,.53.93,2.27,2.27,0,0,1,.09.52c0,.71-.38,1.07-1.56.41a4.14,4.14,0,0,1-2.2-2.85l-3.4-.85a10.91,10.91,0,0,0,4.28,6.14l.09,2.35,2.84,1.57-.09-2.35a3.13,3.13,0,0,0,2.79.11h0c.66-.42,1-1.3.94-2.69-.12-3.09-2-5.11-3.92-6.8s-3.43-2.53-3.49-4c0-.93.58-1,1.5-.5a4.65,4.65,0,0,1,2.26,3.22l3.58.93a10.23,10.23,0,0,0-.41-1.45,9.88,9.88,0,0,0-1.18-2.26,12.44,12.44,0,0,0-2.91-2.89l-.09-2.35-2.81-1.62Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.56,41.34l.07,1.82a2.72,2.72,0,0,0-2.89-.12l-.17.12a2.87,2.87,0,0,0-.87,2.6h0a7.41,7.41,0,0,0,1.14,3.63c.06.09.12.18.17.27l0,0,.19.27.18.23.07.09.14.18a17.92,17.92,0,0,0,1.26,1.34l.65.59.93.8.36.3a13.16,13.16,0,0,1,1.89,1.74,2.52,2.52,0,0,1,.53.93,2.27,2.27,0,0,1,.09.52c0,.71-.38,1.07-1.56.41a4.14,4.14,0,0,1-2.2-2.85l-3.4-.85a10.91,10.91,0,0,0,4.28,6.14l.09,2.35,2.84,1.57-.09-2.35a3.13,3.13,0,0,0,2.79.11h0c.66-.42,1-1.3.94-2.69-.12-3.09-2-5.11-3.92-6.8s-3.43-2.53-3.49-4c0-.93.58-1,1.5-.5a4.65,4.65,0,0,1,2.26,3.22l3.58.93a10.23,10.23,0,0,0-.41-1.45,9.88,9.88,0,0,0-1.18-2.26,12.44,12.44,0,0,0-2.91-2.89l-.09-2.35-2.81-1.62Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,58.51a7.83,7.83,0,0,0-.93-3.22A10.83,10.83,0,0,0,393,52.65c-.8-.79-1.7-1.49-2.56-2.22a9.22,9.22,0,0,1-1.22-1.2,2.62,2.62,0,0,1-.62-1.56,2.52,2.52,0,0,0,.69,1.51,8.38,8.38,0,0,0,1.23,1.15c.88.71,1.78,1.41,2.59,2.2a10.71,10.71,0,0,1,2.08,2.7,7.67,7.67,0,0,1,.61,1.59A8.88,8.88,0,0,1,396,58.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.36 42.37 393.63 41.06 393.71 43.41 391.44 44.72 391.36 42.37",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.36 42.37 393.63 41.06 393.71 43.41 391.44 44.72 391.36 42.37",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.54 40.75 391.1 42.51 391.44 44.72 391.36 42.37 388.54 40.75",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.43 59.53 389.75 61.73 392.36 63.45 389.52 61.88 389.43 59.53",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.15,53.39a10.49,10.49,0,0,0,.42,1.27l.93-.93Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,58.41a7.51,7.51,0,0,0-1.07-3.52l-5.47,5.46.06,1.53L391.46,63l.85-.85,0-1a5.39,5.39,0,0,0,.78.25Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.73,46.22a7,7,0,0,0,.53,2.08l6-6-1.65-1-1,1,0,.81a3,3,0,0,0-.55-.29Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,49.69l.19.27.18.23.07.09.14.18a17.92,17.92,0,0,0,1.26,1.34l.3.27,2-2a3.55,3.55,0,0,1-1.54-2.42c0-.93.58-1,1.5-.5a4.41,4.41,0,0,1,1.53,1.43l1.95-2a12.75,12.75,0,0,0-2.14-1.93l0-.88-5.57,5.56.16.26Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-44"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-44",
    cx: 110.59,
    cy: 418.35,
    rx: 52.85,
    ry: 30.52,
    style: {
      fill: "#2C5A78",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--arm--inject-44",
    d: "M73.07,271,81,250.89l-1.22-24.68c-5,.41-8.52,2.23-11.16,8.43s-7.95,26.15-9,30.8a42.37,42.37,0,0,0-.91,12.31c.24,5.26,2.55,14.77,3.42,19.95.41,2.4.62,4.71.86,7.15a53.43,53.43,0,0,0,1.74,7.41,6.81,6.81,0,0,0,1.8,3.1c.54.55,1.33.67,1.84,1.19s.59,1.34,1.33,1.79,1.83.31,2.54.81a21.66,21.66,0,0,0,2.19,1.7,4.72,4.72,0,0,1,1.87,1.3c.45.58.82,1.82,1.71,1.8s1.24-1,1.36-1.78a7.57,7.57,0,0,0-1.21-4.59,43.4,43.4,0,0,0-2.52-4.34,10.67,10.67,0,0,1-1.77-4.36c-.23-1.05,0-2.35,1.25-1.65,1.5.84,3,2.45,4.91,2.29,1.31-.12,1.47-1.13.78-2a38.83,38.83,0,0,1-3-4.74c-.91-1.68-1.63-3.45-2.59-5.1a23.2,23.2,0,0,0-1.72-2.47c-1.72-2.22-1.41-5-1.41-7.65C72.07,283.85,72.74,275.65,73.07,271Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.89,224.82c-7.29.64-10.91,5.27-13.38,12.57-2.53,7.48-6.24,20.9-7,24.46A49.76,49.76,0,0,0,58,275a123.63,123.63,0,0,0,1.87,14s1.91,1.15,6,1.09c5.67-.09,6.8-1.81,6.8-1.81l1-17.22,8-19.9Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.17,413.69c0,1.29-.24,1.79,1.34,2.95s5,1.7,7.6,1a7.06,7.06,0,0,0,4.21-2.54,35.79,35.79,0,0,0,2.44-3.68c.45-.58,2.57-1.69,4.61-2.6s6.28-2.86,7.75-6.35a8.29,8.29,0,0,0,.46-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.91,396c-4.16,2.72-7.67,9.55-13.36,7.47-.29,3.35-1.18,6.95-.38,10.24,2.43,3,7.74,3.58,10.8,1.42,1.55-1.31,2.41-2.86,3.9-4.24a14.72,14.72,0,0,1,4.1-2.5,43,43,0,0,0,5-2.74C107.13,398.84,102.56,386.41,87.91,396Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,429.35c0,1.39.09,2.44.94,3s7.24,1.65,8.94,1.84,2-.92,3.14-.52,4,2.43,8.13,3.35,7.57,1.9,13.35,0,6.35-4.15,6.27-6.1S102.6,429.35,102.6,429.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.43,416.3c-.93,4-1.92,10-.83,13.05,1.16,1.15,5.07,1.83,8.47,2.29a26.32,26.32,0,0,1,9,2.8c6.6,2.76,18.22,3.76,22.85-2.45,4.62-8.31-19.43-6.26-22.38-15.87C119.48,412.62,107.8,417.25,103.43,416.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.32,369.08C75.54,335,73.88,307.68,77,280.2c0,0,47.93-1.2,49.11,15.08,0,0,.73,58.05.35,65.22-.17,7.26-4.52,52.58-4.52,57.7-11.91,5.91-19.29,1.45-19.29,1.45.07-6.62-5.1-32.31-2.29-48.43L98.4,343.85s-8.17,49-9.55,62.24c-3.52,5.21-13.49,4-15.16.84C73.69,406.93,71.19,379.13,72.32,369.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4,343.85l-2.11-26.36s-9-1.66-14.25-8.19c1.42,5.23,7.09,9.76,10.69,11l3.58,22.37-1.48,20.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,338.68a164.34,164.34,0,0,1-1.94,18.73c-1.23,6.88-4.71,43.11-5.53,51.68a7.81,7.81,0,0,0,.81-.29c.87-9.18,4.27-44.49,5.48-51.25a164.39,164.39,0,0,0,2-18.82c.43-6.82.83-13.26,1.27-16.61l-.76-.1C92.86,325.39,92.46,331.85,92,338.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.84,420.49c1-15.46,3.5-50.55,3.3-66.19-.24-18.67-.87-47.72-2.38-59.78l-.76.09c1.5,12,2.13,41.05,2.37,59.7.2,15.69-2.3,51.09-3.32,66.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,313.71c4.22-4.25,3.63-13.15,3.26-18.7q-.06-.7-.09-1.32l.77-.05c0,.41,0,.85.09,1.31.39,5.92,1,15.56-4,19.84Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-44"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.74 220.1 105.81 231.68 88.78 231.83 91.48 219.35 107.74 220.1",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89,199.5c1.26,1.51,5.18,6.09,5.34,7l-3,2Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.75,188c4.89-.66,8.17,2.74,9.86,13.13.07.41.69,1,1.19,2.59,2.14,6.64,1.21,13.05.12,14.78-2.78,2.36-5.91,3.29-10.5,3-3.49-.2-12.42-1-17-5.62-5.45-5.4-8.35-13.68-4.69-18.11C87.82,191.54,101.06,188.34,103.75,188Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.92,218.48c-.6,1-4.07,3.06-7.44,3.15l.26-1.84A24.69,24.69,0,0,0,114.92,218.48Z",
    style: {
      fill: "#af6152"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.07,206.59a.89.89,0,0,1-1.59.31,11.67,11.67,0,0,0-1.8-2,4.41,4.41,0,0,0-3-.93c-4,.42-2.89,5.69-.87,7.48,3.31,2.93,5,.28,5,.28s2.45,5.06-.85,8.14c0,0-6,1.73-10.66.43-3.52-3.6-5.6-4.93-8-8-5.66-7.38-6.62-16.81-3.18-19-.26-2.66,1.08-6.72,6.5-9.18,5.17-2.35,8.67-2.22,12.46-2.11s8.48,1.71,11.91-1.31a7.21,7.21,0,0,1-.41,6.56,2.38,2.38,0,0,1,2.16,4.23,1.86,1.86,0,0,1,.91,2.19,2.24,2.24,0,0,1-1.92,1.5,9.48,9.48,0,0,1-2.38-.09c-1,3.12-4.48,4.29-6.55,4.21C105.21,202,105.57,205.13,105.07,206.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.61,232.09c-3.55-3.2-2.47-3.37-4.78-5.26-2.86-2.36-15.4-5.29-16.41-4.27a13.81,13.81,0,0,1-3.7,2.74s.59,1.93,8.16,3.76C101.11,230.81,104,230.57,110.61,232.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,223.84c4.17.7,11.69,2.72,15.64,3.8S113,232.3,113,232.3s7.6,3.31,8.53,4.35,2.85,5.83,3.61,16.24,1.38,49.89,1.38,49.89a51.41,51.41,0,0,1-5,1.22l-1.44-11.84-1.61,12.42s-14.29,1-26.26-1.53-17.28-10.2-17.28-10.2,1.79-21,1.31-25.29-4.22-22.27-3.8-29.35,3.11-12.74,7.48-13.39C85.21,224,88,223.84,88,223.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,226c1.08.42,2.19.75,3.3,1.07s2.23.65,3.35,1c2.24.61,4.47,1.22,6.72,1.77s4.5,1,6.79,1.39L113,232.3c-2.32-.11-4.64-.33-6.94-.62a53.65,53.65,0,0,1-6.88-1.25c-2.26-.57-4.5-1.2-6.71-1.92A45.7,45.7,0,0,1,86,226Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.28,240.44c1,4.68,1.71,9.41,2.21,14.17A91.81,91.81,0,0,1,93,269l-.8,14.31-.46,7.16-.53,7.15.21-7.17.27-7.16.66-14.32A100.13,100.13,0,0,0,92,254.66c-.19-2.38-.45-4.75-.74-7.12S90.62,242.8,90.28,240.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.61,287.91c4.11-.66,5.5-2,5.5-2v3a16.12,16.12,0,0,1-5.5,1.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Briefcase--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.75,332.93l-.12,36.87c0,1.79,1.25,2.83,2.8,3.74l3.87,2.26a3.71,3.71,0,0,0,3,.6,8,8,0,0,0,2.08-.84l.08,0,.21-.12,39.71-22.75a9.34,9.34,0,0,0,4.7-8.09l.12-33.57a2.68,2.68,0,0,0-1.2-2.09l-6.61-3.84a2.64,2.64,0,0,0-2.4,0l-45,25.81a2.38,2.38,0,0,0-.86.89A2.45,2.45,0,0,0,106.75,332.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.75,332.93l-.12,36.87c0,1.79,1.25,2.83,2.8,3.74l3.87,2.26a3.71,3.71,0,0,0,3,.6,8,8,0,0,0,2.08-.84h0c-1.55.71-2.77-.09-2.76-1.92l.12-34.74a3.64,3.64,0,0,1,.54-1.8l-9.19-5.34A2.45,2.45,0,0,0,106.75,332.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.76,338.89a4,4,0,0,1,1.83-3.15l42.57-24.39c1.68-1,3.06-.17,3.05,1.77l-.1,31.44a9.37,9.37,0,0,1-4.71,8.09L118.69,375.4c-1.69,1-3.06.17-3-1.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55,306.3l-45.12,26.11a4.25,4.25,0,0,0-2.11,3.63L110.2,374l.68.4.13-38.34a3.52,3.52,0,0,1,1.76-3l45.47-26.31Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.54,311l0,5.71,2.23,1.3,0-7.58c0-.4-.27-.55-.61-.36Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.54,311l0,5.71,2.23,1.3,0-7.58c0-.4-.27-.55-.61-.36Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83,316.55l0,9.24,2.12,1.25,1.44-.83,0-7.58a1.36,1.36,0,0,1,.61-1.06l10.9-6.24,2.26-1.3c.34-.19.62,0,.61.36l0,7.58,1.44-.83,0-9.24a.49.49,0,0,0,0-.12,1.35,1.35,0,0,0-.6-.94l-.91-.53a1.32,1.32,0,0,0-1.22,0l-16,9.18A1.35,1.35,0,0,0,125.83,316.55Z",
    style: {
      fill: "#2C5A78"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,317.79l0,9.25,1.44-.83,0-7.58a1.36,1.36,0,0,1,.61-1.06l10.9-6.24,2.26-1.3c.34-.19.62,0,.61.36l0,7.58,1.44-.83,0-9.24a.49.49,0,0,0,0-.12c-.05-.3-.3-.41-.6-.23l-16,9.18A1.35,1.35,0,0,0,128,317.79Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.42,309a71.6,71.6,0,0,1-2-8.79c-.54-3.11-.38-6.26-.68-12.09l-13.33,3.41a85.33,85.33,0,0,1,2.1,8.56c.57,3.11-.55,5.93-.53,9a7.1,7.1,0,0,0,1.08,3.93c.42.62,1,1.14,1.37,1.75.81,1.21.78,2.07-.43,2.76a1.49,1.49,0,0,0-.61,1.44,3,3,0,0,0,1.44.93,3,3,0,0,0,.73.11c.25,0,.54-.13.78-.11s.48.2.76.22a3.84,3.84,0,0,0,.83-.09,2.62,2.62,0,0,0,1.45-.6c.38-.37.53-1,1-1.24.61-.4,1.42-.08,2.14-.12a2.09,2.09,0,0,0,1.7-1.15,2.37,2.37,0,0,1,.54-1c.3-.24.73-.22,1.09-.37a1.66,1.66,0,0,0,.88-1C143.39,312.84,142.91,310.81,142.42,309Z",
    style: {
      fill: "#c8856a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.22,237.94c3.52,1.77,4.4,2.5,6.33,6.42s4.48,14.69,5.23,21.17,2.65,12.69,3.11,19.28.42,11.91.42,11.91a16.51,16.51,0,0,1-6.1,1.73,20.57,20.57,0,0,1-6.39,0s-4.93-18.19-6.21-23.16-5.89-18.47-5.89-18.47c-1.55-8.78.6-18.66,3-21.85C118.73,235,121.7,236.16,125.22,237.94Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.1,138.4a22.13,22.13,0,0,1-5.95,15.13l-1.84,1.75a22.12,22.12,0,0,1-31.25-31.11l1.75-1.84A22.12,22.12,0,0,1,119.1,138.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,114.43A24,24,0,0,0,93,162.13l2.72,7a1.39,1.39,0,0,0,2.6,0l2.68-7a24,24,0,0,0-4.11-47.68Zm22.2,24a22.13,22.13,0,0,1-5.95,15.13l-1.84,1.75a22.12,22.12,0,0,1-31.25-31.11l1.75-1.84A22.12,22.12,0,0,1,119.1,138.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.1,138.4a22.13,22.13,0,0,1-5.95,15.13l-1.84,1.75a22.12,22.12,0,0,1-31.25-31.11l1.75-1.84A22.12,22.12,0,0,1,119.1,138.4Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Star--inject-44",
    d: "M97.46,126.41l3.05,7.57,8.13.56a.54.54,0,0,1,.31,1l-6.25,5.23,2,7.91a.54.54,0,0,1-.81.59L97,144.9l-6.91,4.33a.55.55,0,0,1-.82-.59l2-7.91L85,135.5a.55.55,0,0,1,.32-1l8.13-.56,3-7.57A.55.55,0,0,1,97.46,126.41Z",
    style: {
      fill: "#2C5A78"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.1f8328aa64e1c221b833ce684e79da7c.svg";
export { ForwardRef as ReactComponent };